import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';

export default function ViewClinics({ clinics, showInactive, setShowInactive }) {
    const { user } = useAuth();
    const [filteredClinics, setFilteredClinics] = useState([]);
    const [searchTerm, setSearchTerm] = useState([]);
    const navigate = useNavigate();

    //Filter clinics by search term
    useEffect(() => {
        const term = typeof searchTerm === 'string' ? searchTerm.trim().toLowerCase() : '';

        if (!term.trim()) {
            setFilteredClinics(clinics);
        } else {
            const lower = searchTerm.toLowerCase();
            const filtered = clinics.filter(
                clinic => clinic.clinic_name.toLowerCase().includes(lower) ||
                String(clinic.clinic_id).includes(lower) ||
                (clinic.timezone && clinic.timezone.toLowerCase().includes(lower))
            );
            setFilteredClinics(filtered);
        }
    }, [searchTerm, clinics]);


    const handleViewClinic = (clinicId) => {
        navigate(`/practice/clinics/${clinicId}`);
    }

    return (
        <div className='p-4 max-w-7xl mx-auto bg-gray-50'>
            {clinics && <h2 className='text-3xl mb-6 font-bold text-center'>Registered Clinics</h2>}

            <div className='grid grid-cols-1 md:grid-cols-2 gap-1'>
                {/* Search bar  */}
                <div className='mb-6 w-full mx-auto'>
                    <input type='text' placeholder="Search by name, ID, or timezone" value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} className='w-full rounded-lg border border-gray-300 p-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-docpgrPurple10' />
                </div>
                {/* Toggle to show inactive clinics  */}
                {user?.role === 'super_admin' && (
                    <div className='flex items-center justify-center mb-4'>
                        <label className='flex items-center space-x-2 text-sm text-gray-700'>
                            <input type='checkbox' checked={showInactive} onChange={() => setShowInactive(!showInactive)} className='h-4 w-4 accent-docpgrPurple10' />
                            <span>Show Inactive Clinics</span>
                        </label>
                    </div>
                )}
            </div>

            <ul className='grid grid-cols-1 divide-y divide-gray-200 rounded-lg border bg-white shadow-sm '>
                {filteredClinics.length > 0 ? (
                    filteredClinics.map((clinic) => (
                        <li key={clinic.clinic_id} className={`p-4  cursor-pointer transition ${clinic.is_active ? 'hover:bg-gray-100' : 'bg-gray-100 opacity-70'}`} onClick={() => handleViewClinic(clinic.clinic_id)}>
                            <div className='font-semibold text-gray-800'>
                                {clinic.clinic_name}
                            </div>
                            <div className='text-sm text-gray-500'>
                                ID: {clinic.clinic_id}{' '}
                                {clinic.timezone ? `Timezone: ${clinic.timezone}` : ''}
                            </div>
                        </li>
                    ))
                ) : ( 
                    <li className='p-4 text-center text-gray-500 italic'>
                        No clinics found
                    </li>
                )}
            </ul>
        </div>
    )
}